export const RISK_BOND_EDITABLE_FIELDS = ['Fitch', 'Moody', 'SAndP']
